module.exports = "<p>\n  departaments works!\n</p>\n"